module.exports = __webpack_public_path__ + "static/img/Kobe-Hetherington.972e7ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kobe-Hetherington.jpg
// module id = 7gEn
// module chunks = 0